import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as AlarmManager from '../domain/alarm-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { AlarmChannelDetailsType } from '../../types/alarm-channel-type';

type ContextState = Data<AlarmChannelDetailsType>;
const Context = React.createContext<ContextState | null>(null);

function useAlarmChannelDetails(): ContextState {

    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useAlarmChannelDetails details must be used within a channel detail');
    }

    return contextState;
};

const AlarmChannelDetailDataProvider: React.FC<{ deviceId: string; alarmId: string }> = (props) => {

    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'alarm-channel',
        id: props.deviceId,
        dataFn: React.useCallback(() => AlarmManager.getAlarmChannelDetailResponse(authHelper, props.deviceId,props.alarmId), [
            authHelper,
            props.deviceId,
            props.alarmId
        ])
    });
    const alarmChannelDetail = dataFromDataset(dataset);
  
    return <Context.Provider value={alarmChannelDetail}>{props.children}</Context.Provider>;
};
const TestAlarmChannelDetailDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { AlarmChannelDetailDataProvider, TestAlarmChannelDetailDataProvider, useAlarmChannelDetails };
